export default __webpack_public_path__ + "static/media/search.039c3b1e.png";